import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    Output,
    computed,
    OnInit,
    signal,
    ViewChild,
} from "@angular/core";
import { S25PipesModule } from "../../../../../pipes/s25.pipes.module";
import { S25EditableModule } from "../../../../s25-editable/s25.editable.module";
import { S25LoadingInlineModule } from "../../../../s25-loading/s25.loading.inline.module";
import { S25SimpleCollapseModule } from "../../../../s25-simple-collapse/s25.simple.collapse.module";
import { Table } from "../../../../s25-table/Table";
import { TypeManagerDecorator } from "../../../../../main/type.map.service";
import { S25Util } from "../../../../../util/s25-util";
import { UserprefService } from "../../../../../services/userpref.service";
import { S25Datefilter } from "../../../../s25-dateformat/s25.datefilter.service";
import { S25EventOccurrencesService } from "../../s25.event.occurrences.service";
import { S25ProfileUtil } from "../../../utils/s25.profile.util";
import { S25LoadingApi } from "../../../../s25-loading/loading.api";
import { S25Reservation, S25RmReservation, S25RsReservation } from "../../../ReservationI";
import { S25Event } from "../../../EventMicroI";
import { S25Profile, AdditionalTime, Ids } from "../../../ProfileI";
import { EventMicroService } from "../../../../../services/event.micro.service";
import { S25ReservationUtil } from "../../../utils/s25.reservation.util";
import { SpaceService } from "../../../../../services/space.service";
import { S25RmReservationUtil } from "../../../utils/s25.rm.reservation.util";
import { NotificationService } from "../../../../../services/notification.service";
import { S25Const } from "../../../../../util/s25-const";
import { TelemetryService } from "../../../../../services/telemetry.service";
import { FlsService } from "../../../../../services/fls.service";
import { Fls } from "../../../../../pojo/Fls";
import { S25ModalModule } from "../../../../s25-modal/s25.modal.module";
import { S25ModalComponent } from "../../../../s25-modal/s25.modal.component";
import { S25ConflictsModule } from "../../../../s25-conflicts/s25.conflicts.module";
import { AvailWSResponse, ResourceSpaceAvailService } from "../../../../../services/resource.space.avail.service";
import { AvailCheck } from "../../../../../pojo/AvailabilityCheck";
import { SpaceConflictErrorUtil } from "../../../utils/space.conflict.error.util";
import { S25ObjectSearchUtil } from "../../../../s25-object-search/s25.object.search.util";
import { ResourceService } from "../../../../../services/resource.service";
import WSSpaceAvail = AvailWSResponse.WSSpaceAvail;
import WSResourceAvail = AvailWSResponse.WSResourceAvail;
import DateElement = AvailWSResponse.DateElement;
@TypeManagerDecorator("s25-ng-occurrence-added-time")
@Component({
    selector: "s25-ng-occurrence-added-time",
    template: ` @if (init) {
        <div>
            <s25-simple-collapse [header]="'Additional Time'" [expanded]="false">
                <div class="collapseContainer">
                    <section class="res-data">
                        <div class="c-margin-top--half" tabindex="0">
                            Reservation Start: <span class="ngBold c-displayBlock">{{ reservationStartDt }}</span>
                        </div>
                        <div class="c-margin-top--half c-margin-bottom--half" tabindex="0">
                            Reservation End: <span class="ngBold c-displayBlock">{{ reservationEndDt }}</span>
                        </div>
                        <div class="rose-form--additional-time--summary c-text-align--center" tabindex="0">
                            Reservation Duration:
                            <span class="c-displayBlock ngBold">{{ reservationDuration }}</span>
                        </div>
                        @if (isTimeChanged) {
                            <div class=" c-margin-top--single c-margin-bottom--half">
                                <button class="aw-button aw-button--primary c-margin-right--single" (click)="save()">
                                    Save
                                </button>
                                <button class="aw-button aw-button--outline c-margin-right--single" (click)="cancel()">
                                    Cancel
                                </button>
                            </div>
                        }
                        <s25-loading-inline [model]="{}" class="c-margin-top--single"></s25-loading-inline>
                    </section>
                    <div class="divider"></div>
                    <section>
                        @if (initTimes) {
                            @for (a of additionalTime; track a; let i = $index) {
                                <div class="c-margin-bottom--half">
                                    <div tabindex="0">
                                        <b>{{ a.label }}</b>
                                    </div>
                                    <div class="inline-editable-container">
                                        <s25-ng-editable-number
                                            [(val)]="a.days"
                                            [readOnly]="readOnly || !hasPerm"
                                            [min]="0"
                                            [max]="999"
                                            [ariaLabel]="a.days + ' Days, edit ' + a.label + ' days'"
                                            (change)="onChange()"
                                        >
                                        </s25-ng-editable-number>
                                        <span class="c-margin-right--half">Days </span>
                                        <s25-ng-editable-number
                                            [(val)]="a.hours"
                                            [readOnly]="readOnly || !hasPerm"
                                            [min]="0"
                                            [max]="23"
                                            [ariaLabel]="a.hours + ' Hours, edit ' + a.label + ' hours'"
                                            (change)="onChange()"
                                        >
                                        </s25-ng-editable-number>
                                        <span class="c-margin-right--half">Hours </span>
                                        <s25-ng-editable-number
                                            [(val)]="a.minutes"
                                            [readOnly]="readOnly || !hasPerm"
                                            [min]="0"
                                            [max]="59"
                                            [ariaLabel]="a.minutes + ' Minutes, edit ' + a.label + ' minutes'"
                                            (change)="onChange()"
                                        >
                                        </s25-ng-editable-number>
                                        <span class="c-margin-left--half">Minutes </span>
                                    </div>
                                </div>
                            }
                        }
                    </section>
                </div>
            </s25-simple-collapse>

            <s25-ng-modal #spaceConflictModal [title]="'Conflicts'" [size]="'md'">
                <ng-template #s25ModalBody>
                    <p class="c-margin-bottom--half">{{ spaceConflictMessage() }}</p>
                    <s25-ng-conflicts [model]="displayConflicts()"></s25-ng-conflicts>
                </ng-template>
            </s25-ng-modal>
        </div>
    }`,
    styles: [
        `
            :host ::ng-deep .collapseContainer {
                display: flex;
                justify-content: space-evenly;
                padding-block: 1rem;
            }

            .res-data {
                display: flex;
                flex-direction: column;
                align-items: center;

                .rose-form--additional-time--summary {
                    width: 15rem;
                    padding-inline: 10px;
                }
            }

            .divider {
                border-left: 1px solid #e5e5e5;
            }

            .inline-editable-container {
                display: flex;
                align-items: center;
                justify-content: space-between;
            }

            .inline-editable-container > s25-ng-editable-number {
                margin-right: 10px;
            }

            .inline-editable-container > s25-ng-editable-number:last-of-type {
                margin-right: 0;
            }

            :host ::ng-deep .c-svgIcon:hover {
                cursor: pointer;
            }
        `,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        S25SimpleCollapseModule,
        S25LoadingInlineModule,
        S25EditableModule,
        S25PipesModule,
        S25ModalModule,
        S25ConflictsModule,
    ],
})
export class OccurrenceAddedTimeComponent implements OnInit {
    @Input() occ?: S25Reservation;
    @Input() readOnly?: boolean;
    @Input() profileId?: number;
    @Output() refreshF = new EventEmitter();

    @ViewChild("spaceConflictModal") spaceConflictModal?: S25ModalComponent;
    readonly displayConflicts = signal<AvailCheck.ConflictDefaults[]>([]);
    readonly spaceConflictMessage = signal(SpaceConflictErrorUtil.SAVE_BLOCKED_MESSAGE);

    init: boolean = false;
    additionalTime: AdditionalTime[] = [
        { id: "setupStart", label: "Setup Time", days: 0, hours: 0, minutes: 0 },
        { id: "preEventStart", label: "Pre-Event Time", days: 0, hours: 0, minutes: 0 },
        { id: "postEventEnd", label: "Post-Event Time", days: 0, hours: 0, minutes: 0 },
        { id: "takeDownEnd", label: "Takedown Time", days: 0, hours: 0, minutes: 0 },
    ];

    reservationDuration: string;
    reservationStartDt: string;
    reservationEndDt: string;
    event: S25Event;
    profile: S25Profile;
    findResourcesConflict: any[] = [];
    findLocationConflict: any[] = [];
    hasConflict: boolean = false;

    dateTimeformat: string;
    isTimeChanged: boolean = false;
    hasPerm: boolean = true;
    fls: Fls;
    initTimes: boolean = false;

    profiles = computed(() => {
        return this.occurrencesService.getProfiles();
    });

    constructor(
        private cd: ChangeDetectorRef,
        private elementRef: ElementRef,
        private occurrencesService: S25EventOccurrencesService,
    ) {}

    async ngOnInit() {
        this.event = this.occurrencesService.S25Event();
        this.profile = await S25ProfileUtil.getProfileByProfileId(this.profiles(), this.profileId);
        this.setAdditionalTime();
        await this.setReservationDurations();
        this.hasPerm = S25ReservationUtil.checkObjHasPerm(this.occurrencesService.getOccurrences());
        this.fls = await FlsService.getFls();
        this.initTimes = true;
        this.init = true;
        this.cd.detectChanges();
    }

    async onChange() {
        this.profile = await S25ProfileUtil.getProfileByProfileId(this.profiles(), this.profileId);
        this.isTimeChanged = true;
        this.updateOccDates();
        this.cd.detectChanges();
    }

    setAdditionalTime() {
        const addedTime = this.profile?.occurrenceDefn?.addedTime;
        this.updateAdditionalTime("preEventStart", addedTime?.preEvent || "P0DT0H0M");
        this.updateAdditionalTime("postEventEnd", addedTime?.postEvent || "P0DT0H0M");
        this.updateAdditionalTime("setupStart", addedTime?.setup || "P0DT0H0M");
        this.updateAdditionalTime("takeDownEnd", addedTime?.takedown || "P0DT0H0M");
    }

    getDurationString(startDt: Date, endDt: Date) {
        const minuteDur = S25Util.date.diffMinutes(startDt, endDt);
        return S25Util.getDurationString(minuteDur);
    }

    async setReservationDurations() {
        if (!this.profile?.reservations[0]) return;
        const rsrv: S25Reservation = this.profile?.reservations[0] as S25Reservation;
        this.dateTimeformat = await UserprefService.getS25DateTimeformat();

        const preEventStart = this.additionalTime.find((item) => item.id === "preEventStart");
        const setupStart = this.additionalTime.find((item) => item.id === "setupStart");
        const preEventStartMillis = this.timeToMilliseconds(
            preEventStart.days,
            preEventStart.hours,
            preEventStart.minutes,
        );
        const setupStartMillis = this.timeToMilliseconds(setupStart.days, setupStart.hours, setupStart.minutes);
        const rsrvStartDate = new Date(rsrv.eventStart.getTime() - preEventStartMillis - setupStartMillis);
        this.reservationStartDt = S25Datefilter.transform(rsrvStartDate, this.dateTimeformat);

        const postEventEnd = this.additionalTime.find((item) => item.id === "postEventEnd");
        const takeDownEnd = this.additionalTime.find((item) => item.id === "takeDownEnd");
        const postEventEndMillis = this.timeToMilliseconds(postEventEnd.days, postEventEnd.hours, postEventEnd.minutes);
        const takeDownEndMillis = this.timeToMilliseconds(takeDownEnd.days, takeDownEnd.hours, takeDownEnd.minutes);
        const rsrvEndDate = new Date(rsrv.eventEnd.getTime() + postEventEndMillis + takeDownEndMillis);
        this.reservationEndDt = S25Datefilter.transform(rsrvEndDate, this.dateTimeformat);

        this.reservationDuration = this.getDurationString(rsrvStartDate, rsrvEndDate);

        this.cd.detectChanges();
    }

    updateAdditionalTime(id: Ids, duration: string) {
        if (duration) {
            const getDHM = S25Util.ISODurationToObj(duration);
            const timeItem = this.additionalTime.find((item) => item.id === id);
            if (timeItem) {
                timeItem.days = getDHM.days;
                timeItem.hours = getDHM.hours;
                timeItem.minutes = getDHM.minutes;
            }
            return timeItem;
        }
    }

    updateOccDates() {
        const addTime = (date: Date, days: number, hours: number, minutes: number) => {
            return new Date(date.getTime() + this.timeToMilliseconds(days, hours, minutes));
        };

        this.additionalTime.forEach((time: any) => {
            switch (time.id) {
                case "setupStart":
                    this.profile?.reservations?.forEach((rsrv: any) => {
                        rsrv.setupStart = addTime(rsrv.eventStart, -time.days, -time.hours, -time.minutes);
                        if (rsrv.preEventStart)
                            rsrv.setupStart = addTime(
                                rsrv.setupStart,
                                -this.additionalTime[1].days,
                                -this.additionalTime[1].hours,
                                -this.additionalTime[1].minutes,
                            ); // subtract  pre event times
                    });
                    break;
                case "preEventStart":
                    this.profile?.reservations?.forEach((rsrv: any) => {
                        rsrv.preEventStart = addTime(rsrv.eventStart, -time.days, -time.hours, -time.minutes);
                        if (rsrv.setupStart)
                            rsrv.setupStart = addTime(
                                rsrv.preEventStart,
                                -this.additionalTime[0].days,
                                -this.additionalTime[0].hours,
                                -this.additionalTime[0].minutes,
                            ); // also update set up times
                    });
                    break;
                case "postEventEnd":
                    this.profile?.reservations?.forEach((rsrv: any) => {
                        rsrv.postEventEnd = addTime(rsrv.eventEnd, time.days, time.hours, time.minutes);
                        if (rsrv.takeDownEnd)
                            rsrv.takeDownEnd = addTime(
                                rsrv.postEventEnd,
                                this.additionalTime[3].days,
                                this.additionalTime[3].hours,
                                this.additionalTime[3].minutes,
                            ); // update take Down times
                    });
                    break;
                case "takeDownEnd":
                    this.profile?.reservations?.forEach((rsrv: any) => {
                        rsrv.takeDownEnd = addTime(rsrv.eventEnd, time.days, time.hours, time.minutes);
                        if (rsrv.postEventEnd)
                            rsrv.takeDownEnd = addTime(
                                rsrv.takeDownEnd,
                                this.additionalTime[2].days,
                                this.additionalTime[2].hours,
                                this.additionalTime[2].minutes,
                            ); // add post event time
                    });
                    break;
                default:
                    break;
            }
        });
        this.setReservationDurations();
        this.cd.detectChanges();
    }

    cancel() {
        this.findResourcesConflict = [];
        this.findLocationConflict = [];
        this.displayConflicts.set([]);
        this.hasConflict = false;
        this.initTimes = false;
        this.cd.detectChanges();
        this.ngOnInit();
    }

    async save() {
        const liveEvent = this.occurrencesService.S25Event();
        if (!liveEvent || this.profileId == null) return;

        const liveProfile = await S25ProfileUtil.getProfileByProfileId(this.profiles(), this.profileId); // ANG-5898
        if (!liveProfile) return;

        // Work on a clone — mutating liveEvent.profile / reservation dates was blanking the occ table
        const workingProfile = S25Util.clone(liveProfile);
        this.profile = workingProfile;
        this.updateOccDates();

        const addedTime = S25ProfileUtil.normalizeAddedTime(this.additionalTime);
        workingProfile.occurrenceDefn.addedTime =
            Object.keys(addedTime).length === 0 ? { setup: "", preEvent: "", postEvent: "", takedown: "" } : addedTime;

        const eventForSave: S25Event = {
            ...liveEvent,
            profile: [workingProfile],
        };

        const normalizeData = await S25ProfileUtil.normalizeProfileWSData(eventForSave, eventForSave.profile);
        const data = normalizeData[0].data;

        // ANG-7691: space_avail first — only PUT when the extended window is clear
        this.setLoading(true);
        try {
            await this.checkObjectsAvailability(liveEvent.itemId, this.fls);
        } catch (caughtError) {
            this.hasConflict = true;
            this.setLoading(false);
            return S25Util.showError(caughtError, "There was an error while checking for conflicts.");
        }
        if (this.hasConflict) {
            this.setLoading(false);
            this.cd.detectChanges();
            return false;
        }

        this.isTimeChanged = false;
        this.cd.detectChanges();
        TelemetryService.sendWithSub("EventDetails", "EventDetailsOcc", "EditMode");
        const [ok, error] = await S25Util.Maybe(
            this.occurrencesService.runInlineEditScenarios(liveEvent.itemId, () =>
                EventMicroService.microPutEventDetail(data, liveEvent.itemId),
            ),
        );

        if (ok) {
            if (ok?.content?.errors || ok?.content?.messages) {
                for (const putError of ok?.content?.errors || ok?.content?.messages) {
                    NotificationService.post(putError.message);
                }
            }
            this.occurrencesService.getEvent(liveEvent.itemId, false, ok); //fetch newUpateData
            this.refreshF.emit(this.profileId);
        }
        this.setLoading(false);

        if (error) {
            if (await this.showSpaceConflictFromPutError(error, liveEvent.itemId, workingProfile)) {
                return false;
            }
            this.cancel();
            return S25Util.showError(error, "There was an error while attempting to update this profile.");
        }
    }

    /** ANG-7691: surface EV_E_SPACECON_TIME detail messages in the Conflicts modal. */
    private async showSpaceConflictFromPutError(
        error: unknown,
        eventId: number,
        workingProfile: S25Profile,
    ): Promise<boolean> {
        const reservations = (workingProfile.reservations as S25Reservation[]) ?? [];
        const locations = reservations.flatMap((rsrv) =>
            rsrv.locations?.length ? S25RmReservationUtil.getLocationsFlat(rsrv.locations[0] as S25RmReservation) : [],
        );
        const parsed = SpaceConflictErrorUtil.parsePutError(error, locations);
        if (!parsed) return false;

        this.isTimeChanged = true;
        this.hasConflict = true;
        this.spaceConflictMessage.set(parsed.summary);
        this.displayConflicts.set(parsed.conflicts);
        this.cd.detectChanges();
        void this.spaceConflictModal?.open();

        this.displayConflicts.set(
            await SpaceConflictErrorUtil.enrichWithAvailTimes(parsed.conflicts, {
                dates: S25ReservationUtil.getReservationsStartEndDates(reservations),
                eventId,
                profileId: this.profileId,
                fls: this.fls,
            }),
        );
        this.cd.detectChanges();
        return true;
    }

    setLoading(yes: boolean) {
        if (yes) {
            S25LoadingApi.init(this.elementRef.nativeElement);
        } else {
            S25LoadingApi.destroy(this.elementRef.nativeElement);
        }
        this.cd.detectChanges();
    }

    timeToMilliseconds(days: number, hours: number, minutes: number) {
        return days * S25Const.ms.day + hours * S25Const.ms.hour + minutes * S25Const.ms.min;
    }

    /**
     * Check locations/resources for the extended reservation window before PUT.
     * Uses non-overridable conflict rules (same as object-search / ANG-7706) so rsrv
     * conflicts are not skipped when a space also has overridable hours/blackout rows.
     */
    async checkObjectsAvailability(eventId: number, fls: Fls) {
        this.hasConflict = false;
        this.findLocationConflict = [];
        this.findResourcesConflict = [];
        this.displayConflicts.set([]);

        const reservations = (this.profile.reservations as S25Reservation[]) ?? [];
        const dates = S25ReservationUtil.getReservationsStartEndDates(reservations);
        if (!dates.length) return;

        const locationArr: S25RmReservation[] = [];
        const resourceArr: S25RsReservation[] = [];
        for (const rsrv of reservations) {
            if (rsrv.locations?.length) {
                locationArr.push(...S25RmReservationUtil.getLocationsFlat(rsrv.locations[0] as S25RmReservation));
            }
            if (rsrv.resources?.length) {
                resourceArr.push(
                    ...(S25ReservationUtil.getObjectsFlat(rsrv.resources[0] as S25RsReservation) as S25RsReservation[]),
                );
            }
        }

        const uniqueLocations = S25Util.array.uniqueByProp(locationArr, "itemId");
        const spaceIds = uniqueLocations.map((item) => item.itemId).filter((id) => !!id && Number.isFinite(id));
        const resources = S25Util.array.uniqueByProp(
            resourceArr.filter((resource) => !!resource.itemId && Number.isFinite(resource.itemId)),
            "itemId",
        );

        if (!spaceIds.length && !resources.length) return;

        const [spaceAvailability, resourceAvailability] = await Promise.all([
            spaceIds.length
                ? SpaceService.getSpaceDatesAvailability(spaceIds, dates, eventId, this.profileId)
                : Promise.resolve(undefined),
            resources.length
                ? ResourceService.getResourceDatesAvailability(resources, dates, eventId, this.profileId)
                : Promise.resolve(undefined),
        ]);

        const findLocationConflict =
            spaceAvailability?.spaces?.space?.filter(
                (space: WSSpaceAvail) =>
                    space.has_conflicts === "T" &&
                    !space.dates?.every(
                        (date: DateElement) =>
                            !date.conflict?.length ||
                            date.conflict.every((conflict) =>
                                S25ObjectSearchUtil.canOverrideConflict(conflict.conflict_type, fls),
                            ),
                    ),
            ) ?? [];
        const findResourcesConflict =
            resourceAvailability?.resources?.resource?.filter(
                (resource: WSResourceAvail) => resource.has_conflicts === "T",
            ) ?? [];

        const displayConflicts: AvailCheck.ConflictDefaults[] = [];
        if (findLocationConflict.length) {
            displayConflicts.push(
                ...ResourceSpaceAvailService.toDisplayConflicts(
                    { spaces: { space: findLocationConflict } },
                    "space",
                    fls,
                ),
            );
        }
        if (findResourcesConflict.length) {
            displayConflicts.push(
                ...ResourceSpaceAvailService.toDisplayConflicts(
                    { resources: { resource: findResourcesConflict } },
                    "resource",
                    fls,
                ),
            );
        }

        this.findLocationConflict = findLocationConflict;
        this.findResourcesConflict = findResourcesConflict;
        this.displayConflicts.set(displayConflicts);
        this.hasConflict = findLocationConflict.length > 0 || findResourcesConflict.length > 0;

        if (this.hasConflict) {
            this.spaceConflictMessage.set(SpaceConflictErrorUtil.SAVE_BLOCKED_MESSAGE);
            this.cd.detectChanges();
            void this.spaceConflictModal?.open();
        }
    }

    async refresh() {
        this.profile = await S25ProfileUtil.getProfileByProfileId(this.profiles(), this.profileId);
        this.setAdditionalTime(); // This parses addedTime and updates the UI fields
        await this.setReservationDurations(); // This updates the reservation start/end display
        this.cd.detectChanges();
    }
}
